"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vitor = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
class Vitor extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.VITOR,
            tags: [Tags_1.Tags.EARTH],
            startingMegaCredits: 48,
            initialActionText: 'Fund an award for free',
            metadata: {
                cardNumber: 'R35',
                description: 'You start with 45 M€. As your first action, fund an award for free.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.megacredits(45).nbsp().award();
                    b.corpBox('effect', (ce) => {
                        ce.vSpace();
                        ce.effect('When you play a card with a NON-NEGATIVE VP icon, including this, gain 3 M€.', (eb) => {
                            eb.vpIcon().asterix().startEffect.megacredits(3);
                        });
                    });
                }),
            },
        });
    }
    static selectAwardToFund(player, award) {
        return new SelectOption_1.SelectOption('Fund ' + award.name + ' award', 'Confirm', () => {
            player.game.fundAward(player, award);
            return undefined;
        });
    }
    initialAction(player) {
        if (player.game.isSoloMode() && player.game.gameOptions.automaSoloVariant) {
            const orOptions = new OrOptions_1.OrOptions();
            orOptions.title = 'Claim a milestone';
            orOptions.options = player.game.milestones.map((ms) => player.claimMilestone(ms));
            return orOptions;
        }
        return Vitor.fundAwardForFree(player);
    }
    static fundAwardForFree(player) {
        const game = player.game;
        if (game.isSoloMode())
            return;
        if (game.allAwardsFunded())
            return;
        const freeAward = new OrOptions_1.OrOptions();
        freeAward.title = 'Select award to fund';
        freeAward.buttonLabel = 'Confirm';
        const availableAwards = game.awards.filter((award) => !game.fundedAwards.map((fa) => fa.award).includes(award));
        freeAward.options = availableAwards.map((award) => Vitor.selectAwardToFund(player, award));
        return freeAward;
    }
    onCardPlayed(player, card) {
        if (player.isCorporation(this.name) && card.getVictoryPoints !== undefined && card.getVictoryPoints(player) >= 0) {
            player.megaCredits += 3;
        }
    }
    play(player) {
        if (player.game.isSoloMode() && player.game.gameOptions.automaSoloVariant) {
            this.initialActionText = 'Claim a milestone for free';
        }
        return undefined;
    }
}
exports.Vitor = Vitor;
//# sourceMappingURL=Vitor.js.map